"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "laion": {
    "92b46e44": [{
      "hkey": "e7c5ad40",
      "slug": "laion",
      "name": "Laion",
      "primary": true,
      "skipSearch": false
    }],
    "fraina": [{
      "hkey": "e7c5ad40",
      "slug": "laion",
      "name": "Laion",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0be85e76": [{
      "hkey": "039f356f",
      "slug": "novale-di-sotto",
      "name": "Novale di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "novale": [{
      "hkey": "039f356f",
      "slug": "novale-di-sotto",
      "name": "Novale di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a159dde3": [{
      "hkey": "13c9c054",
      "slug": "san-pietro",
      "name": "San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "s-pietro": [{
      "hkey": "13c9c054",
      "slug": "san-pietro",
      "name": "San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;